import { useContext } from 'react';
import { ContexteAuthentification, type ContexteAuth } from './context';

export function useAuth(): ContexteAuth {
  const contexte = useContext(ContexteAuthentification);
  if (!contexte) {
    throw new Error('useAuth doit être utilisé dans un FournisseurAuth');
  }
  return contexte;
}

export function useAuthOptionnel(): ContexteAuth | null {
  return useContext(ContexteAuthentification);
}
